import { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'notistack'
import { Panel } from '../Panel'
import { ProfileDetailForm, ProfileDetailFormRef } from './ProfileDetailForm'
import { useDispatch, useSelector } from '../../store'
import {
  setEditingDeviceAccess,
  updateDeviceAccess,
} from 'store/slices/deviceAccess'
import { showHttpError } from 'utils/helpers'
import { useMutation, useQuery } from '@apollo/client'
import { UPDATE_PROFILE } from 'lib/mutations/profile'
import { GET_PROFILE } from 'lib/queries/profile'

export const EditProfilePanel = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { enqueueSnackbar } = useSnackbar()
  const formRef = useRef<ProfileDetailFormRef>({
    getFormData: () => Promise.resolve(undefined),
  })
  const { editingDeviceAccess } = useSelector((state) => state.deviceAccesses)
  const [isValid, setIsValid] = useState(false)
  const [updateProfile, { data, loading, error }] = useMutation(UPDATE_PROFILE)

  const { data: getData } = useQuery(GET_PROFILE, {
    variables: { getProfileId: editingDeviceAccess || '' },
  })
  const edittingProfile = getData?.getProfile

  const onSubmit = async () => {
    if (!editingDeviceAccess) {
      return
    }
    const formData = await formRef.current.getFormData()
    if (formData) {
      updateProfile({
        variables: { updateProfileId: editingDeviceAccess, dto: formData },
      })
    }
    if (formData) {
      if (loading) return 'Updating...'
      if (error)
        return showHttpError(enqueueSnackbar, error, 'Updating profile failed')

      enqueueSnackbar('Your changes are saved successfully', {
        variant: 'success',
      })
      onClose()
    }
  }

  const onClose = () => {
    dispatch(setEditingDeviceAccess(undefined))
  }

  return (
    <Panel
      className="w-157"
      open={!!editingDeviceAccess}
      title={t('editProfilePanel.title') as string}
      submitButtonText={t('editProfilePanel.submit') as string}
      isValid={isValid}
      disableBackdrop
      onSubmit={onSubmit}
      onClose={onClose}
    >
      {edittingProfile && (
        <ProfileDetailForm
          formRef={formRef}
          profile={edittingProfile}
          onValidate={setIsValid}
          data-testid="detailed-form"
        />
      )}
    </Panel>
  )
}
